export default {
	translate(obj){
		let newObj = {};
		Object.keys(obj).forEach( name => {
			newObj[name] = this.$t(obj[name]);
		});
		return newObj;
	},

	basename(str) {
		var base = new String(str).substring(str.lastIndexOf('/') + 1);
		if(base.lastIndexOf(".") != -1)
			base = base.substring(0, base.lastIndexOf("."));
		return base;
	},

	copyToClipboard(text) {
	    if (window.clipboardData && window.clipboardData.setData) {
	        // IE specific code path to prevent textarea being shown while dialog is visible.
	        return window.clipboardData.setData("Text", text);

	    } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
	        var textarea = document.createElement("textarea");
	        textarea.textContent = text;
	        textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
	        document.body.appendChild(textarea);
	        textarea.select();
	        try {
	            return document.execCommand("copy");  // Security exception may be thrown by some browsers.
	        } catch (ex) {
	            console.warn("Copy to clipboard failed.", ex);
	            return false;
	        } finally {
	            document.body.removeChild(textarea);
	        }
	    }
	},

	getFieldValidation(field){
		let out = {};
		if(field.required) out.required = true;
		if(field.type == 'email') out.email = true;
		if(field.min) out.min = field.min;
		if(field.max) out.max = field.max;
		if(field.name =='password') out.confirmed = 'password_confirmation';
		if(field.type == 'select' && field.options.length <= 1) out.required = false;

		if((field.name == 'password' || field.name == 'password_confirmation') && field.value.length > 0) out.required = 'true';

		return out;
	},
};



// WEBPACK FOOTER //
// ./src/helpers/general.js